import { BoundingBoxIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Zone = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <BoundingBoxIcon size={Sizes[size]} {...rest} color={fill} />;
};

Zone.displayName = 'Zone';
